/**
 * PWA: service-worker registration + install-prompt capture.
 * Not used inside the Android app: its pages are loaded through Capacitor,
 * and a service worker would bypass the native bridge injection.
 */
import { isNativeApp } from "./platform";

let deferredPrompt = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn(!!deferredPrompt));

export const canPromptInstall = () => !!deferredPrompt;
export const onInstallAvailabilityChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
export const promptInstall = async () => {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  notify();
  return outcome;
};

export const initPWA = () => {
  if (typeof window === "undefined" || isNativeApp()) return;

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault(); // we show our own "Install app" button
    deferredPrompt = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });

  if (import.meta.env.PROD && "serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch((err) => {
        console.warn("Service worker registration failed:", err?.message);
      });
    });
  }
};
